import { eq, string } from '@code-expert/prelude';
export const eqEntityById = eq.struct({
    _id: string.Eq,
});
//# sourceMappingURL=Entity.js.map